import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';

const outerWallList = {
 north: {
  'Verlist': { "x": 698.1886, "y": 8.0, "z": 2746.41968 },
  "coordinate": { "longitude": 118.2716984922896, "latitude": 39.513314503847532 }
 },
 south: {
  "Verlist": { "x": 937.2864, "y": 8.0, "z": -379.7871 },
  "coordinate": { "longitude": 118.27440465084544, "latitude": 39.4853979488093 }
 },
 west: {
  "Verlist": { "x": -461.919434, "y": 8.0, "z": 1160.9729 },
  "coordinate": { "longitude": 118.25856814746095, "latitude": 39.499156703281557 }
 },
 east: {
  "Verlist": { "x": 2088.14648, "y": 8.0, "z": 1124.73987 },
  "coordinate": { "longitude": 118.28743032573107, "latitude": 39.498833147769318 }
 },
}

export const UIjson = {
 success: true,
 code: 1,
 msg: "查询成功",
 data: [
  {
   id: "north",
   url: "https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/outerWall.html?pageId=2" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
   size: {
    x: 2000,
    y: 500,
   },
   pos: {
    x: 698,
    y: 0,
    z: 2746
   },
   scale: 2800,
   pixel: 2000,
   hight: 700,
   towardsCam: false,
   rotation: 177
  },
  {
   id: "south",
   url: "https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/outerWall.html?pageId=2" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
   size: {
    x: 2000,
    y: 500,
   },
   pos: {
    x: 937,
    y: 0,
    z: -380
   },
   scale: 2800,
   pixel: 2000,
   hight: 700,
   towardsCam: false,
   rotation: 0
  },
  {
   id: "west",
   url: "https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/outerWall.html?pageId=1" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
   size: {
    x: 2300,
    y: 500,
   },
   pos: {
    x: -462,
    y: 0,
    z: 1161
   },
   scale: 3300,
   pixel: 2300,
   hight: 700,
   towardsCam: false,
   rotation: 87
  },
  {
   id: "east",
   url: "https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/outerWall.html?pageId=1" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
   size: {
    x: 2300,
    y: 500,
   },
   pos: {
    x: 2088,
    y: 0,
    z: 1125
   },
   scale: 3300,
   pixel: 2300,
   hight: 700,
   towardsCam: false,
   rotation: -93
  },
 ]
};